<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="790">
        <v-card>
          <v-card-title class="headline">To use microDecaPodVT you must Sign In</v-card-title>
          <v-card-text>Signing up transfers no rights or responsibilities: signing-up/in incurs no contract, commitment, tracking, advertising, spyware, adware, gelocation data scraping or other internet bummers.
            </v-card-text>
            <v-card-text>
          This app is "beta" and will become a subscription service, a pay-to-use application, or leased software. At present, however, general feedback and criticism is the order of the day.
          </v-card-text>
            <v-card-text>Thank you, Sebastian Noah Frank, 2017</v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                flat
                outline
                @click.native='Dsignin'
              >
                <v-icon left>lock_open</v-icon>
                Sign-in with e-mail
              </v-btn>
              <!--v-spacer></v-spacer-->
              <!--v-btn
                flat
                outline
                @click.native='Gsignin'
              >
                <v-icon>lock_open</v-icon>
                Sign-in with Google
              </v-btn-->
              <v-spacer></v-spacer>
              <v-btn
                flat
                outline
                @click.native='Dsignup'
              >
                <v-icon left>face</v-icon>
                Sign-up
              </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="dialog = !dialog">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-toolbar color="info" dense app height="40" elevation-1>
      <v-btn flat :to="'/schoolindex'">{{ schTitle }}</v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          flat
          outline
          :to="'/signin'"
        >
          <v-icon left>lock_open</v-icon>
          Sign-in with e-mail
        </v-btn>
        <!--v-spacer></v-spacer-->
        <!--v-btn
          flat
          outline
          :to="'/fireui'"
        >
          <v-icon>lock_open</v-icon>
          Sign-in with Google
        </v-btn-->
        <v-spacer></v-spacer>
        <v-btn
          flat
          outline
          :to="'/signup'"
        >
          <v-icon left>face</v-icon>
          Sign-up
        </v-btn>
        <v-divider></v-divider>
      </v-toolbar-items>
      <v-toolbar-title>
        <router-link to="/" tag="span" style="cursor: pointer">microDecaPodVT</router-link>
      </v-toolbar-title>
    </v-toolbar>
      <v-layout row wrap >
        <v-flex xs1>
          <v-navigation-drawer class="info" clipped permanent app width="60">
            <v-btn
              small fab color="deco"
              disabled
              :to="'/pixelpicker'"
              >
              {{ setPixel }}
            </v-btn>
            <v-divider></v-divider>
            <v-btn
              :to="'/timepicker'"
              disabled
              small fab color="five"
              >
              {{ minute5to60[0] }}
            </v-btn>
            <v-btn
              :to="'/timepicker'"
              disabled
              small fab color="ten"
              >
              {{ minute5to60[1] }}
            </v-btn>
            <v-btn
              :to="'/timepicker'"
              disabled
              small fab color="fifteen"
              >
              {{ minute5to60[2] }}
            </v-btn>
            <v-btn
              :to="'/timepicker'"
              disabled
              small fab color="twenty"
              >
            {{ minute5to60[3] }}
            </v-btn>
            <v-btn
              :to="'/timepicker'"
              disabled
              small fab color="twentyfive"
              >
              {{ minute5to60[4] }}
            </v-btn>
            <v-btn
              :to="'/timepicker'"
              disabled
              small fab color="thirty"
              >
              {{ minute5to60[5] }}
            </v-btn>
            <v-btn
              :to="'/timepicker'"
              disabled
              small fab color="thirtyfive"
              >
              {{ minute5to60[6] }}
            </v-btn>
            <v-divider></v-divider>
              © SNF
              {{ new Date().getFullYear() }}
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs10 v-if="!dialog">
          <router-view></router-view>
        </v-flex>
      </v-layout>
      <v-footer dense color="info" class="hidden-md-and-down">
        <v-spacer></v-spacer>
        <div>© Sebastian Noah Frank {{ new Date().getFullYear() }}</div>
      </v-footer>
    </div>
</template>

<script>
export default {
  data () {
    return {
      dialog: true
    }
  },
  computed: {
    invertStatus () {
      return this.$store.getters.inverse
    },
    minute5to60 () {
      return this.$store.getters.minutes
    },
    /*
    minute5 () {
      return this.$store.getters.minutes[0]
    },
    minute10 () {
      return this.$store.getters.minutes[1]
    },
    minute15 () {
      return this.$store.getters.minutes[2]
    },
    minute20 () {
      return this.$store.getters.minutes[3]
    },
    minute25 () {
      return this.$store.getters.minutes[4]
    },
    minute30 () {
      return this.$store.getters.minutes[5]
    },
    minute35 () {
      return this.$store.getters.minutes[6]
    },
    */
    schTitle () {
      return this.$store.getters.schoolName
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    setPixel () {
      return this.$store.getters.pixel
    }
  },
  methods: {
    Dsignin () {
      this.dialog = false
      this.$router.push('/signin')
    },
    /*
    Gsignin () {
      this.dialog = false
      this.$router.push('/fireui')
    },
    */
    Dsignup () {
      this.dialog = false
      this.$router.push('/signup')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User/notSignedIn.vue